import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_URL,
});

instance.interceptors.request.use(
  function (config) {
    let token = localStorage.getItem("data")
      ? JSON.parse(localStorage.getItem("data")).token
      : "";
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  function (response) {
    if (response.data.code == 401) {
      localStorage.clear();
      window.location.href = "/#/login";
    }
    return response.data;
  },
  function (error) {
    if (error.response) {
      if (error.response.status == 401) {
        localStorage.clear();
        window.location.href = "/#/login";
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
